import { CustomFieldRenderer } from './CustomFieldRenderer'
import type { CustomFieldDefinitionDocument, CustomFieldValueDocument } from './types'
import type { CustomFieldGroupDocument } from '@/lib/db/rxdb/hooks/entities/custom-field-groups'

interface CustomFieldTabContentProps {
  ungrouped: Array<CustomFieldDefinitionDocument>
  groups: Array<{ group: CustomFieldGroupDocument; fields: Array<CustomFieldDefinitionDocument> }>
  valueMap: Map<string, CustomFieldValueDocument>
  taskId: string
  readOnly?: boolean
}

/**
 * Renders one tab's contents for the task detail view: ungrouped fields first, then
 * each group with its name as a heading and its fields below. Empty when both
 * `ungrouped` and `groups` are empty (parent already auto-hides empty tabs).
 */
export function CustomFieldTabContent({
  ungrouped,
  groups,
  valueMap,
  taskId,
  readOnly = false,
}: CustomFieldTabContentProps) {
  return (
    <div className="flex flex-col gap-6">
      {ungrouped.length > 0 && (
        <div className="flex flex-col gap-3">
          {ungrouped.map((field) => (
            <CustomFieldRenderer
              key={field.id}
              definition={field}
              value={valueMap.get(field.id)}
              taskId={taskId}
              readOnly={readOnly}
            />
          ))}
        </div>
      )}
      {groups.map(({ group, fields }) => (
        <section key={group.id} className="flex flex-col gap-2">
          <h4 className="text-sm font-medium text-muted-foreground">{group.name}</h4>
          <div className="flex flex-col gap-3">
            {fields.map((field) => (
              <CustomFieldRenderer
                key={field.id}
                definition={field}
                value={valueMap.get(field.id)}
                taskId={taskId}
                readOnly={readOnly}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  )
}
